import { createSelector } from '@reduxjs/toolkit';

// The function below is called a selector and allows us to select a value from the state.
export const createCustomSelector = (selector) => createSelector(selector, (val) => val);
